module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARBAMAAAAmgTH3AAAAKlBMVEUAAAD///////////////////////////////////////////////////+Gu8ovAAAADnRSTlMAESIzRFVmd4iZqrvM3UwhkGcAAABtSURBVAjXY2BgYBBRYAADyeO7DUA041YG5ksgBnsBA4MniMEtwMDAA2ZAMQOnAwODDIjBdJCBYSpYe05KdAGYwVReBDHQvbzcASwzzcW1pxCoqRHEqxFgyARLszcwHIQovACEYLCEoXs3GCwAABUFF2CpmM7oAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/reg.png
// module id = 654
// module chunks = 0